import React, { useState } from 'react';
import * as Icons from 'lucide-react';
import { ChevronDown } from 'lucide-react';

// Curated set of icons for admin to pick from
const ICON_OPTIONS = [
  'Award', 'Factory', 'Users', 'ShieldCheck', 'Flame', 'CheckCircle',
  'Target', 'Eye', 'Cog', 'Wrench', 'FlaskConical', 'Search', 'Truck',
  'PackageCheck', 'Package', 'Layers', 'Building2', 'Star', 'Heart',
  'ThumbsUp', 'Phone', 'Mail', 'MapPin', 'Globe', 'Zap', 'Lightbulb',
  'Settings', 'Tool', 'Hammer', 'Shield', 'BadgeCheck', 'Crown',
  'Sparkles', 'Sun', 'Activity', 'TrendingUp', 'Inbox',
];

export function getIcon(name) {
  return Icons[name] || Icons.Star;
}

export default function IconPicker({ value, onChange, label = 'Icon' }) {
  const [open, setOpen] = useState(false);
  const Current = getIcon(value);

  return (
    <div className="relative">
      {label && <label className="text-sm font-medium leading-none">{label}</label>}
      <button type="button" onClick={() => setOpen(o => !o)}
        className="mt-1 w-full flex items-center justify-between gap-2 border border-gray-200 rounded px-3 py-2 text-sm bg-white hover:bg-gray-50">
        <span className="inline-flex items-center gap-2"><Current className="w-4 h-4 text-[#f7941e]" /> {value || 'Pick icon'}</span>
        <ChevronDown className="w-4 h-4 text-gray-400" />
      </button>
      {open && (
        <div className="absolute z-30 top-full left-0 right-0 mt-1 bg-white border border-gray-200 rounded shadow-lg p-2 max-h-64 overflow-y-auto grid grid-cols-6 gap-1">
          {ICON_OPTIONS.map(n => {
            const I = getIcon(n);
            return (
              <button type="button" key={n} onClick={() => { onChange(n); setOpen(false); }} title={n}
                className={`p-2 rounded hover:bg-[#fff7e6] flex items-center justify-center ${value === n ? 'bg-[#f7941e] text-white' : 'text-gray-700'}`}>
                <I className="w-4 h-4" />
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
